<template>
  <ion-app>
    <div id="app" v-if="standalone || isCordova">
      <ion-router-outlet />
    </div>
    <div class="appPaddings" style="font-family: 'Open Sans',sans-serif" v-else>
      <h1 style="font-size: 1.4em;">Die FFIpS-App für Smartphone oder Tablet</h1>
    <p>Über die <strong>FFIpS-App</strong> der DELATTINIA und der Saarländischen Akademie für Artenkenntnis können faunistische und botanische Erfassungen direkt im Feld oder nachträglich an das <strong> <a href="https://ffips.de/" target="_blank">FFIpS Datenportal </a></strong> übermittelt werden. Dazu ist dort eine <strong>vorherige Registrierung</strong> erforderlich. Wenn Sie bereits ein Konto auf dem Portal haben, halten Sie für die App-Installation Ihre Zugangsdaten bereit. Benutzernahme oder E-Mail und Passwort müssen für die Nutzung der App einmalig eingegeben werden.
    </p><h1 style="font-size: 1.2em;">Vorschau</h1>
      <div class="rowi">
        <div class="columni">
          <img src="img/ScreenListe.webp">
        </div>
        <div class="columni">
          <img src="img/ScreenFunde.webp">
        </div>
        <div class="columni">
          <img src="img/ScreenKarte.webp">
        </div>
      </div>
      <h1 style="font-size: 1.2em;">Installationsanleitung auf Android-Smartphones für die Browser Chrome (empfohlen) sowie Firefox und Edge</h1>
        <ol>
            <li>Öffnen Sie diese Seite auf Ihrem Android Smartphone oder Tablet.</li>
            <li>Tippen Sie auf das Menü rechts neben der Adressleiste und danach auf „Zum Startbildschirm hinzufügen“ (Chrome, Firefox) bzw. „Zum Smartphone hinzufügen“ (Edge).</li>
            <li>Nach Ihrer Bestätigung wird die App auf dem Smartphone oder Tablet installiert.</li>
        </ol>
        <h1 style="font-size: 1.2em;">Installationsanleitung auf dem iPhone oder iPad für die Browser Safari und Firefox</h1>
        <ol>
            <li>Öffnen Sie diese Seite auf Ihrem iPhone oder iPad.</li>
            <li>Tippen Sie auf das Teilen-Symbol und wählen Sie „Zum Home-Bildschirm“ aus. Auf Ihrem iPhone befindet sich das Teilen-Symbol in der unteren Menüleiste. Auf Ihrem iPad befindet sich das Teilen-Symbol rechts oben neben der Adressleiste.
            </li>
            <li>Bestätigen Sie die Installation, indem sie auf „Hinzufügen“ tippen.</li>
            <li>Nach Ihrer Bestätigung wird die App auf dem Smartphone oder Tablet installiert.</li>
        </ol>
        <h1 style="font-size: 1.2em;">Nach der Installation</h1>
        <p>Falls bereits installiert, wird auf dieser Intro-Seite das Symbol zum Öffnen angezeigt, aber besser benutzt man dann direkt das Appsymbol auf dem Desktop - diese Informationsseite wird nach der Installation nicht mehr benötigt. Beim Installieren werden die App-Inhalte im Hintergrund heruntergeladen, danach benötigt die App nur für eventuelle Updates, sowie das Hoch- und Herunterladen von Daten mit Attributen das Internet.</p>
        <h1 style="font-size: 1.2em;">Zur Version 1.2.3</h1>
        <p>Die FFIpS-App wird von der Naturforschenden Gesellschaft des Saarlandes, DELATTINIA e.V. zur Verfügung gestellt. Die App wurde im Rahmen des Projektes FörTax – Förderung von taxonomischem Wissen als Grundlage für den Naturschutz / Saarländische Akademie für Artenkenntnis erstellt. Wesentliches Ziel der FFIpS-App ist grundlegendes Vereinfachen der Meldung von Artbeobachtungen für das Faunistisch Floristische Informationsportal des Saarlandes und des Saar-Mosel-Raums. Gemeldete Beobachtungen können auf dem Portal von Artspezialisten verifiziert oder plausibilisiert werden und stehen anderen Nutzern zur Recherche zur Verfügung</p>
        <p>Die App kann nach der Installation im Gelände auch Offline genutzt werden. Beobachtungsdaten können bis zur Meldung an das Portal nachbearbeitet werden. Weitere Hilfe zur Installation sowie Tipps und Tricks zur effizienten Nutzung der App unter können Sie der <a href="https://ffips.de/hilfe-zur-app" target="_blank">Nutzungsanleitung </a>entnehmen</p><br><br><br><br>
    </div>
  </ion-app>
</template>
<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue'
import { defineComponent } from 'vue'
export default defineComponent({
  components: {
    IonApp,
    IonRouterOutlet
  },
  data () {
    return {
      standalone: window.matchMedia('(display-mode: standalone)').matches,
      isCordova: window.cordova
    }
  },
  created () {
    window.matchMedia('(display-mode: standalone)').addEventListener('change', (evt) => {
      window.location.reload()
    })
  },
})
</script>
<style>
.appPaddings {
  background-color: inherit;
  overflow: auto;
  padding-left: .3rem;
  padding-right: .3rem;
  position: absolute;
  width: 100%;
  height: 100vh;
}
.rowi {
  display: flex;
}

.columni {
  flex: 33.33%;
  padding-left: 1%;
  padding-right: 1%;
}
.material-icons.materialIcons {
  font-size: 2rem;
  position: relative;
  top: .6rem;
  line-height: 10%;
}
.material-icons.icons-menu {
  font-size: 1rem;
  position: relative;
  top: .4rem;
}
.material-icons.crosshair {
  font-size: 40px;
  color: magenta;
  opacity: .7;
  left: -14px;
  top: -14px;
  z-index: 10000;
  cursor: grab;
}
.material-icons.locate::before { 
  content: "gps_fixed";
}
.marker-pin {
  width: 30px;
  height: 30px;
  border-radius: 50% 50% 50% 0;
  position: absolute;
  transform: rotate(-45deg);
  left: 50%;
  top: 50%;
  margin: -15px 0 0 -15px;
}
.marker-pin::after {
  content: '';
  width: 24px;
  height: 24px;
  margin: 3px 0 0 3px;
/*background: #fff;*/
  position: absolute;
  border-radius: 50%;
}

.custom-div-icon i {
  position: absolute;
  width: 1.7rem;
  font-size: .9rem;
  line-height: .8rem;
  color: white;
  left: 0;
  right: 0;
  margin: 10px auto;
  text-align: center;
}
</style>
